module.exports = __webpack_public_path__ + "static/media/hclogo.ce2556d1.png";